import axios from 'axios'
import Methods from './methods/index'
// import store from '@/store'
import StorageAuth from '@/store/modules/authComponents/storage'
import qs from 'qs'
import str from 'sprintf-js'
import Responses from './responses'
// import toast from '@/components/toastPlugin'
const setHeader = function () {
  let token = StorageAuth.getToken()
  if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + StorageAuth.getToken()
  }
}
const prepareReq = function (method, params) {
  let response = {
    url: '',
    params: params
  }
  let strReplaceParam = null
  if (typeof (method) === 'object') {
    strReplaceParam = method
    method = strReplaceParam.splice(0, 1)[0]
  }
  setHeader()
  response['url'] = Methods.generateUrl(method)
  if (strReplaceParam !== null) {
    response['url'] = str.vsprintf(response['url'], strReplaceParam)
  }
  return response
}

const httpPost = function (method, params) {
  let generateReq = prepareReq(method, params)
  return axios.post(generateReq['url'], generateReq['params'])
    .then(resp => {
      return Responses.succcesResponse(resp)
    })
    .catch(function (error) {
      Responses.errorResponse(error)
      throw error
    })
}

const httpGet = function (method, params) {
  let generateReq = prepareReq(method, params)
  if (generateReq['params']) {
    generateReq['url'] = generateReq['url'] + '?' + qs.stringify(generateReq['params'])
  }
  return axios.get(generateReq['url'])
    .then(resp => {
      return Responses.succcesResponse(resp)
    })
    .catch(function (error) {
      Responses.errorResponse(error)
      throw error
    })
}
const httpPut = function (method, params) {
  let generateReq = prepareReq(method, params)
  return axios.put(generateReq['url'], generateReq['params'])
    .then(resp => {
      return Responses.succcesResponse(resp)
    })
    .catch(function (error) {
      Responses.errorResponse(error)
      throw error
    })
}

const httpPatch = function (method, params) {
  let generateReq = prepareReq(method, params)
  return axios.patch(generateReq['url'], generateReq['params'])
    .then(resp => {
      return Responses.succcesResponse(resp)
    })
    .catch(function (error) {
      Responses.errorResponse(error)
      throw error
    })
}

export default {
  httpPost,
  httpGet,
  httpPut,
  httpPatch
}



// WEBPACK FOOTER //
// ./src/api/calls.js